import { render, staticRenderFns } from "./AppointDetail.vue?vue&type=template&id=671e8bcf&scoped=true&"
import script from "./AppointDetail.vue?vue&type=script&lang=js&"
export * from "./AppointDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointDetail.vue?vue&type=style&index=0&id=671e8bcf&lang=less&scoped=true&"
import style1 from "./AppointDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e8bcf",
  null
  
)

export default component.exports